import template from './time-entry-updates.html';
import controller from './time-entry-updates.controller';

let TimeEntryUpdatesModal = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  controllerAs: "$ctrl",
  windowClass: "hmodal-info animated zoomIn"
};

export default TimeEntryUpdatesModal;



// WEBPACK FOOTER //
// ./client/pages/timesheet/modals/time-entry-updates/time-entry-updates.component.js